import { action, computed } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Image } from 'react-bootstrap';
import { inject, bind } from '../../../../utils/decorators';
import { BpsReferenzkraftKalibrierungRili2021Store } from '../../../../stores/BpsReferenzkraftKalibrierungRili2021Store';
import { Panel, Table, FormControl, FormGroup, Col, ControlLabel } from 'react-bootstrap';
import { round } from '../../../../utils/round';
import { numberformat } from '../../../../utils/numberformat';

@observer
class BpsReferenzkraftRollenDurchmesserMesspunkt extends React.Component<{ x: number, y: number}, {}> {

  @inject(BpsReferenzkraftKalibrierungRili2021Store) store: BpsReferenzkraftKalibrierungRili2021Store;

  @bind @action handleValueChanged(event: React.FormEvent<FormControl>) {
    if (!this.store.readOnly) {
      let neuerWert = isNaN((event.target as HTMLInputElement).valueAsNumber) ? null : (event.target as HTMLInputElement).valueAsNumber;
      this.store.setMesswertRollendurchmesser(this.props.x, this.props.y, neuerWert);
      this.store.berechneMittelwerteRolle();
    }
  }

  render() {
    const { x, y } = this.props;
    const { messwerte } = this.store.datensatz.rollendurchmesser;
    let mw = (messwerte[x][y] !== undefined && messwerte[x][y] !== null) ? messwerte[x][y] : undefined;
    return (
      <FormControl type="number" step="0.1" readOnly={this.store.readOnly} value={mw ? mw : ''} onChange={this.handleValueChanged}/>
    );
  }
}

@observer
class BpsReferenzkraftRollenDurchmesserMittelwerte extends React.Component<{}, {}> {

  @inject(BpsReferenzkraftKalibrierungRili2021Store) kalibrierungStore: BpsReferenzkraftKalibrierungRili2021Store;

  @computed get nenndurchmesser() {
    const { kalibrierGegenstand } = this.kalibrierungStore;
    if (!kalibrierGegenstand) { return undefined; }
    let rollendurchmesser = kalibrierGegenstand.meta('rollendurchmesser');
    if (rollendurchmesser) {
      return parseFloat(rollendurchmesser);
    }
    return undefined;
  }

  renderMittelwert(wertabsolut: number | null) {
    if (!wertabsolut || !this.nenndurchmesser) {
      return <div>-</div>;
    }
    // Wert farblich hervorheben
    let durchmesserRelativ = round(wertabsolut / this.nenndurchmesser * 100, 1);
    let cssClass = durchmesserRelativ < 98 ? 'mittelwert-error' : 'mittelwert-success';
    return (
      <div className={cssClass}>{numberformat(wertabsolut)} (<span className={cssClass}>{numberformat(durchmesserRelativ)}%</span>)</div>
    );
  }

  render() {
    const { datensatz } = this.kalibrierungStore;
    return (
      <tr style={{textAlign: 'center'}}>
        <td colSpan={3}>
          {this.renderMittelwert(datensatz.rollendurchmesser.mittelwert.links)}
        </td>
        <td colSpan={1}>
          Kalibrier-<br/>durchmesser
        </td>
        <td colSpan={3}>
          {this.renderMittelwert(datensatz.rollendurchmesser.mittelwert.rechts)}
        </td>
      </tr>
    );
  }
}

/** Komponente für die Eingabe und Auswertung des Rollendurchmessers des Bremsprüfstands */
@observer
export default class BpsReferenzkraftRollenDurchmesser extends React.Component<{}, {}> {

  @inject(BpsReferenzkraftKalibrierungRili2021Store) store: BpsReferenzkraftKalibrierungRili2021Store;

  @bind @action handleOberflaecheChanged(event: React.FormEvent<FormControl>) {
    this.store.setOberflaeche((event.target as HTMLInputElement).value);
    this.store.berechneMittelwerteRolle();
  }

  @bind @action handleMessungChanged(event: React.FormEvent<FormControl>) {
    this.store.setMessart((event.target as HTMLInputElement).value);
    this.store.berechneMittelwerteRolle();
  }

  @bind @action handleGrunddurchmesserChanged(event: React.FormEvent<FormControl>) {
    this.store.setGrunddurchmesser((event.target as HTMLInputElement).valueAsNumber);
    this.store.berechneMittelwerteRolle();
  }

  render() {
    return (
      <Panel header="Rollendurchmesser" collapsible={true} defaultExpanded={true}>
        {/* Optionen */}
        <Col sm={6}>
          <FormGroup controlId="Oberfläche">
            <Col componentClass={ControlLabel} sm={4}>Oberfläche</Col>
            <Col sm={8}>
              <FormControl componentClass="select" onChange={this.handleOberflaecheChanged} value={this.store.datensatz.oberflaeche} disabled={this.store.readOnly}>
                <option value="beschichtet">Beschichtet</option>
                <option value="geschweisst">Geschweißt</option>
              </FormControl>
            </Col>
          </FormGroup>
        </Col>
        <Col sm={6}>
          <FormGroup controlId="Messung">
            <Col componentClass={ControlLabel} sm={4}>Messung</Col>
            <Col sm={8}>
              <FormControl componentClass="select" onChange={this.handleMessungChanged} value={this.store.datensatz.messart} disabled={this.store.readOnly}>
                <option value="durchmesser">Durchmesser</option>
                <option value="umfang">Umfang</option>
              </FormControl>
            </Col>
          </FormGroup>
        </Col>
        {/* Bei geschweissten Rollen muss der Grunddurchmesser nach Messung manuell eingegeben und in die Berechnung einbezogen werden */}
        {this.store.datensatz.oberflaeche === 'geschweisst' && <Col sm={12}>
          <FormGroup controlId="Grunddurchmesser">
            <Col componentClass={ControlLabel} sm={8}>Grunddurchmesser Rolle</Col>
            <Col sm={4}>
              <FormControl type="number" step="0.1" readOnly={this.store.readOnly} value={this.store.datensatz.rollendurchmesser.grunddurchmesser ? this.store.datensatz.rollendurchmesser.grunddurchmesser.toString() : ''} onChange={this.handleGrunddurchmesserChanged} />
            </Col>
          </FormGroup>
        </Col>}
        {/* Messwerteingabe */}
        <Table striped={false} bordered={false} condensed={true} hover={false} className="bps-eingabe-rolle">
          <thead>
            <tr>
              <th colSpan={3}>Rolle links [mm]</th>
              <th/>
              <th colSpan={3}>Rolle rechts [mm]</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><BpsReferenzkraftRollenDurchmesserMesspunkt x={0} y={0}/></td>
              <td><BpsReferenzkraftRollenDurchmesserMesspunkt x={0} y={1}/></td>
              <td><BpsReferenzkraftRollenDurchmesserMesspunkt x={0} y={2}/></td>
              <td rowSpan={3}><Image src={require('../../../../assets/images/bps_fahrtrichtung.png')} style={{width: '56px'}}/>Fahrtrichtung</td>
              <td><BpsReferenzkraftRollenDurchmesserMesspunkt x={2} y={0}/></td>
              <td><BpsReferenzkraftRollenDurchmesserMesspunkt x={2} y={1}/></td>
              <td><BpsReferenzkraftRollenDurchmesserMesspunkt x={2} y={2}/></td>
            </tr>
            <tr className="position">
              <td>10 cm links</td>
              <td>Mitte</td>
              <td>10 cm rechts</td>
              <td>10 cm links</td>
              <td>Mitte</td>
              <td>10 cm rechts</td>
            </tr>
            <tr>
              <td><BpsReferenzkraftRollenDurchmesserMesspunkt x={1} y={0}/></td>
              <td><BpsReferenzkraftRollenDurchmesserMesspunkt x={1} y={1}/></td>
              <td><BpsReferenzkraftRollenDurchmesserMesspunkt x={1} y={2}/></td>
              <td><BpsReferenzkraftRollenDurchmesserMesspunkt x={3} y={0}/></td>
              <td><BpsReferenzkraftRollenDurchmesserMesspunkt x={3} y={1}/></td>
              <td><BpsReferenzkraftRollenDurchmesserMesspunkt x={3} y={2}/></td>
            </tr>
          </tbody>
          <tfoot>
            <BpsReferenzkraftRollenDurchmesserMittelwerte/>
          </tfoot>
        </Table>
      </Panel>
    );
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/bps/rili2021/BpsReferenzkraftRollenDurchmesser.tsx